import css from 'styled-jsx/css'
import { colors, measurements } from 'theme'

export default css`
  .collapser {
    border: 1px solid ${colors.border};
    margin-top: 1rem;
    border-radius: ${measurements.borderRadius};
  }
  .collapser .collapser-header {
    background-color: ${colors.lightGray};
    display: flex;
    transition: 0.8s;
    justify-content: space-between;
    border-radius: ${measurements.borderRadius};
  }
  .collapser .collapser-header button {
    width: 20%;
    border: none;
    background-color: transparent;
    outline: none;
    display: flex;
    align-items: center;
    color: ${colors.text};
    min-height: 2.5rem;
  }
  .collapser .collapser-header button:hover {
    cursor: pointer;
  }
  .collapser :global(.toggle-icon-collapser) {
    opacity: 0.45;
    margin-right: 0.5rem;
    min-width: 2rem;
  }

  .collapser .collapser-header .header {
    width: 100%;
    padding: 0.5rem;
  }

  .collapser .content {
    overflow: hidden;
    opacity: 0;
    max-height: 0;
    transition: 0.3s;
    padding: 0 0.6rem;
    margin: 0;
  }

  .collapser.is-open .content {
    opacity: 1;
    max-height: none;
    padding: 0.6rem;
    margin: 0.1rem 0 0.2rem;
  }

  .collapser.is-open .collapser-header {
    border-radius: ${measurements.borderRadius} ${measurements.borderRadius} 0 0;
  }
  .collapser .collapser-header.is-inverted button {
    order: 2;
    justify-content: flex-end;
  }

  .collapser.is-open :global(.toggle-icon-collapser) {
    transform: rotate(90deg);
  }

  @media screen and (max-width: 480px) {
    .collapser .collapser-header {
      flex-direction: column;
    }
    .collapser .collapser-header button {
      width: 100%;
    }
    .collapser .collapser-header.is-inverted {
      flex-direction: initial;
    }
    .collapser .collapser-header.is-inverted button {
      width: initial;
    }
  }
`
